export default __webpack_public_path__ + "static/media/Level=3.b628e297.svg";